'use client';

import { usePathname } from 'next/navigation';

import type { JSX } from 'react';

import { Link, type ILinkProps } from './Link';

export function NavLink({
  href,
  containerProps,
  ...rest
}: ILinkProps): JSX.Element {
  const pathname = usePathname();
  const active = pathname === href;

  return (
    <Link
      href={href}
      containerProps={{
        color: active ? 'white' : 'gray.400',
        _after: {
          transform: active ? 'scaleX(1)' : 'scaleX(0)',
        },
        ...containerProps,
      }}
      {...rest}
    />
  );
}
